import { Avatar, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { isNil } from 'lodash';
import React from 'react';
import { useI18n } from '../common/i18n/I18n';
import { Icons } from '../common/icons/Icons';
import { H, V } from '../common/Layout';

export default function OrganizationOptionRenderer({ option, isAIExtractedFlow = false }) {
    const createOption = option && option.createOption;
    const t = useI18n();
    const searchAndClearAllText = t('common.clear.and.search.all', { label: '' });
    const searchForText = t('common.search.for');
    const inactiveText = t('fieldDefinition.inactive');

    const isClearAndSearchOption = option && option.label.includes(searchAndClearAllText);
    const isSearchForOption = option && option.label.includes(searchForText);
    const isInactive = !!option?.inActive;
    const label = createOption ? `Add ${option.label}` : option.label;

    return (
        <H gap={1}>
            {!isAIExtractedFlow && (
                <Avatar sx={{ bgcolor: grey[500], color: 'white' }} aria-label="recipe">
                    <Icons.Business />
                </Avatar>
            )}
            {isAIExtractedFlow && isSearchForOption && <Icons.Search />}

            {isAIExtractedFlow && createOption && !isSearchForOption && !isClearAndSearchOption && <Icons.AddButton />}

            {isAIExtractedFlow && isClearAndSearchOption && <Icons.Close />}
            <V sx={{ width: '100%' }}>
                <Typography sx={{ fontStyle: createOption || isInactive ? 'italic' : 'normal' }}>
                    {label} {isInactive && `(${inactiveText})`}
                </Typography>
                <Typography sx={{ fontStyle: isInactive ? 'italic' : 'normal' }}>
                    {!isNil(option.organizationTypes) &&
                        option.organizationTypes.map((organizationType) => organizationType).join(', ')}
                </Typography>
                <Typography sx={{ fontStyle: isInactive ? 'italic' : 'normal' }}>
                    {option.parentOrganizationName}
                </Typography>
            </V>
        </H>
    );
}
